(function () {
  'use strict';

  var INIT_FLAG = 'aeyaPdpInited';
  var MOBILE = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  function initOffset(root) {
    var announce = document.querySelector('.aeya-announcement');
    var announceSection = (announce && announce.closest('.shopify-section')) || announce;
    var header = document.querySelector('.aeya-header__bar') || document.querySelector('.aeya-header');

    function readVar(name) {
      var v = parseFloat(getComputedStyle(document.body).getPropertyValue(name));
      return isNaN(v) ? 0 : v;
    }

    function apply() {
      var a = announceSection ? Math.round(announceSection.getBoundingClientRect().height) : 0;
      var h = readVar('--header-height');
      if (!h && header) h = Math.round(header.getBoundingClientRect().height);
      root.style.setProperty('--aeya-pdp-offset', (a + h) + 'px');
    }

    apply();
    requestAnimationFrame(apply);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(apply);
      if (announceSection) ro.observe(announceSection);
      if (header) ro.observe(header);
    }
    window.addEventListener('resize', apply, { passive: true });
    window.addEventListener('orientationchange', apply);
  }

  function initGallery(root) {
    var track = root.querySelector('[data-aeya-gallery-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-aeya-dot]'));
    if (!track || dots.length === 0) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-aeya-slide]'));
    if (slides.length === 0) return;

    var current = 0;

    function setActive(index) {
      if (index < 0) index = 0;
      if (index > dots.length - 1) index = dots.length - 1;
      if (index === current) return;
      current = index;
      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var slide = slides[i];
        if (!slide) return;
        if (isMobile()) {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        } else {
          var offset = parseFloat(getComputedStyle(root).getPropertyValue('--aeya-pdp-offset')) || 0;
          var top = slide.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
        setActive(i);
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (isMobile()) return;
          var best = null;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
            }
          });
          if (best) {
            var idx = parseInt(best.target.getAttribute('data-slide-index'), 10);
            if (!isNaN(idx)) setActive(idx);
          }
        },
        { root: null, rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );
      slides.forEach(function (slide) { observer.observe(slide); });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      if (!isMobile()) return;
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : 1;
        setActive(Math.round(track.scrollLeft / step));
      }, 80);
    });
  }

  function formatMoney(cents) {
    var value = (cents / 100);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active
          ? window.Shopify.currency.active
          : 'GBP'
      }).format(value);
    } catch (e) {
      return '£' + value.toFixed(2);
    }
  }

  function updatePriceUI(root, variant) {
    if (!variant) return;
    var priceEl = root.querySelector('[data-aeya-price]');
    if (priceEl && typeof variant.price === 'number') {
      priceEl.textContent = formatMoney(variant.price);
    }
    var klarnaEl = root.querySelector('[data-aeya-klarna-amount]');
    if (klarnaEl && typeof variant.price === 'number') {
      klarnaEl.textContent = formatMoney(Math.round(variant.price / 3));
    }
  }

  function initLowStock(root) {
    var el = root.querySelector('[data-aeya-low-stock]');
    if (!el) return null;
    var threshold = parseInt(el.getAttribute('data-threshold'), 10);
    if (isNaN(threshold)) threshold = 10;
    var inv = {};
    var dataEl = root.querySelector('[data-aeya-inventory]');
    if (dataEl) {
      try { inv = JSON.parse(dataEl.textContent) || {}; } catch (e) { inv = {}; }
    }
    return function (variant) {
      var show = false;
      if (variant) {
        var rec = inv[variant.id];
        if (rec && rec.tracked && rec.available && rec.qty > 0 && rec.qty < threshold) show = true;
      }
      el.hidden = !show;
    };
  }

  function initVariantPicker(root) {
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-aeya-option-group]'));
    if (groups.length === 0) return;
    var idField = root.querySelector('[data-aeya-variant-id]');
    var form = root.querySelector('.aeya-pdp__form');
    var sectionId = root.getAttribute('data-section-id') || '';

    var variants = [];
    var dataEl = root.querySelector('[data-aeya-variants]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }
    }

    function selectedValues() {
      var sel = {};
      groups.forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-option-position'), 10);
        var checked = group.querySelector('[data-aeya-variant-option][aria-checked="true"]');
        if (checked) sel[pos] = checked.getAttribute('data-option-value');
      });
      return sel;
    }

    function resolveVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = v.options || [];
        var match = true;
        for (var pos in sel) {
          if (!Object.prototype.hasOwnProperty.call(sel, pos)) continue;
          if (opts[pos - 1] !== sel[pos]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateAtc(variant) {
      var btn = root.querySelector('[data-aeya-atc]');
      var label = root.querySelector('[data-aeya-atc-label]');
      if (!btn) return;
      var available = variant ? variant.available !== false : true;
      if (available) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        if (label) label.textContent = 'ADD TO BAG';
      } else {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        if (label) label.textContent = 'Sold out';
      }
    }

    groups.forEach(function (group) {
      var pills = Array.prototype.slice.call(group.querySelectorAll('[data-aeya-variant-option]'));
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) {
            p.setAttribute('aria-checked', p === pill ? 'true' : 'false');
          });

          var variant = resolveVariant(selectedValues());
          if (variant && idField) idField.value = variant.id;
          updateAtc(variant);
          if (root._aeyaUpdateLowStock) root._aeyaUpdateLowStock(variant);
          toggleBis(root, variant);
          if (root._aeyaSyncSticky) root._aeyaSyncSticky();
          if (variant) {
            updatePriceUI(root, variant);
            dispatchVariantUpdate(root, variant, form, sectionId);
          }
        });
      });
    });

    var initialVariant = resolveVariant(selectedValues());
    if (initialVariant) toggleBis(root, initialVariant);
    if (initialVariant && root._aeyaUpdateLowStock) root._aeyaUpdateLowStock(initialVariant);
  }

  function dispatchVariantUpdate(root, variant, form, sectionId) {
    var productId = form ? form.getAttribute('action') || '' : '';
    var evt = new Event('variant:update', { bubbles: true });
    evt.detail = {
      resource: variant,
      sourceId: sectionId,
      data: { html: document, productId: productId }
    };
    document.dispatchEvent(evt);
  }

  function postBackInStock(key, addr, variantId) {
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: addr } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    };
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
      body: JSON.stringify(payload)
    });
  }

  function toggleBis(root, variant) {
    var bis = root.querySelector('[data-aeya-bis]');
    if (!bis) return;
    var soldOut = variant ? variant.available === false : false;
    bis.hidden = !soldOut;
    if (!soldOut) {
      var trigger = bis.querySelector('[data-aeya-bis-trigger]');
      var panel = bis.querySelector('[data-aeya-bis-panel]');
      var em = bis.querySelector('[data-aeya-bis-email]');
      if (trigger) trigger.hidden = false;
      if (panel) panel.hidden = true;
      if (em) em.required = false;
    }
  }

  function initBis(root) {
    var bis = root.querySelector('[data-aeya-bis]');
    if (!bis) return;
    var key = bis.getAttribute('data-klaviyo-key');
    var trigger = bis.querySelector('[data-aeya-bis-trigger]');
    var panel = bis.querySelector('[data-aeya-bis-panel]');
    var email = bis.querySelector('[data-aeya-bis-email]');
    var submit = bis.querySelector('[data-aeya-bis-submit]');
    var message = bis.querySelector('[data-aeya-bis-message]');
    var row = bis.querySelector('[data-aeya-bis-row]');
    var idField = root.querySelector('[data-aeya-variant-id]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function () {
      trigger.hidden = true;
      panel.hidden = false;
      if (email) { email.required = true; email.focus(); }
    });

    function showMsg(ok) {
      if (!message) return;
      message.textContent = ok
        ? (message.getAttribute('data-success') || '')
        : (message.getAttribute('data-error') || '');
      message.hidden = false;
      message.classList.toggle('is-error', !ok);
      if (ok && row) row.hidden = true;
    }

    function submitBis() {
      if (!key || !email || !idField) return;
      if (!email.checkValidity()) { email.reportValidity(); return; }
      var addr = email.value.trim();
      var variantId = idField.value;
      if (!addr || !variantId) return;
      if (submit) submit.disabled = true;
      postBackInStock(key, addr, variantId)
        .then(function (res) { showMsg(res.ok || res.status === 202); })
        .catch(function () { showMsg(false); })
        .then(function () { if (submit) submit.disabled = false; });
    }

    if (submit) submit.addEventListener('click', submitBis);
    if (email) {
      email.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submitBis(); }
      });
    }
  }

  function initQuantity(root) {
    var wrap = root.querySelector('[data-aeya-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-aeya-qty-input]');
    var down = wrap.querySelector('[data-aeya-qty-down]');
    var up = wrap.querySelector('[data-aeya-qty-up]');
    var qtyField = root.querySelector('[data-aeya-quantity-field]');
    if (!input) return;

    function read() {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      return n;
    }
    function write(n) {
      input.value = String(n);
      if (qtyField) qtyField.value = String(n);
    }

    if (down) down.addEventListener('click', function () { write(Math.max(1, read() - 1)); });
    if (up) up.addEventListener('click', function () { write(read() + 1); });
    input.addEventListener('change', function () { write(read()); });
    input.addEventListener('input', function () {
      input.value = input.value.replace(/[^0-9]/g, '');
    });
  }

  function initAtc(root) {
    var form = root.querySelector('.aeya-pdp-ajax');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var btn = form.querySelector('[data-aeya-atc]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/javascript' }
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var data;
            try { data = JSON.parse(text); } catch (e) { data = null; }
            return { ok: res.ok, status: res.status, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            document.dispatchEvent(new CustomEvent('cart:error', { detail: result }));
            return;
          }
          return fetch('/cart.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              if (!cart) return;
              var evt = new Event('cart:update', { bubbles: true });
              evt.detail = {
                resource: cart,
                sourceId: form.id || 'aeya-pdp',
                data: { itemCount: cart.item_count, source: 'aeya-pdp-ajax' }
              };
              document.dispatchEvent(evt);
            });
        })
        .catch(function () {})
        .then(function () {
          if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        });
    });
  }

  function initAccordions(root) {
    var wrap = root.querySelector('[data-aeya-accordions]');
    if (!wrap) return;
    var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-aeya-acc]'));

    function setOpen(item, open) {
      var panel = item.querySelector('[data-aeya-acc-panel]');
      var toggle = item.querySelector('[data-aeya-acc-toggle]');
      if (!panel) return;
      if (open) {
        item.dataset.open = 'true';
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        if (item.dataset.open === 'true') {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          /* force reflow so the collapse transition fires */
          void panel.offsetHeight;
        }
        item.dataset.open = 'false';
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        panel.style.maxHeight = '0px';
      }
    }

    items.forEach(function (item) {
      var panel = item.querySelector('[data-aeya-acc-panel]');
      var toggle = item.querySelector('[data-aeya-acc-toggle]');
      if (!panel || !toggle) return;
      panel.style.maxHeight = item.dataset.open === 'true' ? panel.scrollHeight + 'px' : '0px';

      toggle.addEventListener('click', function () {
        var isOpen = item.dataset.open === 'true';
        items.forEach(function (other) { if (other !== item) setOpen(other, false); });
        setOpen(item, !isOpen);
      });
    });

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        var panel = item.querySelector('[data-aeya-acc-panel]');
        if (panel && item.dataset.open === 'true') {
          panel.style.transition = 'none';
          panel.style.maxHeight = 'none';
          var h = panel.scrollHeight;
          panel.style.maxHeight = h + 'px';
          void panel.offsetHeight;
          panel.style.transition = '';
        }
      });
    });
  }

  function initSizeGuide(root) {
    var panel = root.querySelector('[data-aeya-size-guide]');
    var opener = root.querySelector('[data-aeya-size-guide-open]');
    if (!panel || !opener) return;

    var existing = document.getElementById(panel.id);
    if (existing && existing !== panel && existing.parentElement === document.body) {
      existing.parentElement.removeChild(existing);
    }

    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }

    var closers = Array.prototype.slice.call(panel.querySelectorAll('[data-aeya-size-guide-close]'));

    function open() {
      panel.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { panel.classList.add('is-open'); });
      });
      document.documentElement.style.overflow = 'hidden';
      var x = panel.querySelector('.aeya-pdp__size-guide-x');
      if (x) x.focus();
    }

    function close() {
      panel.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () { panel.hidden = true; }, 320);
      opener.focus();
    }

    opener.addEventListener('click', open);
    closers.forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
  }

  function initStickyBar(root) {
    var bar = root.querySelector('[data-aeya-sticky]');
    if (!bar) return;
    var sectionId = root.getAttribute('data-section-id') || '';
    var realAtc = root.querySelector('[data-aeya-atc]');
    var realAtcLabel = root.querySelector('[data-aeya-atc-label]');
    var idField = root.querySelector('[data-aeya-variant-id]');
    if (!realAtc) return;

    var stale = document.querySelector('body > [data-aeya-sticky][data-section-id="' + sectionId + '"]');
    if (stale && stale !== bar) stale.parentElement.removeChild(stale);
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    bar.hidden = false;

    var stickyAtc = bar.querySelector('[data-aeya-sticky-atc]');
    var stickyAtcLabel = bar.querySelector('[data-aeya-sticky-atc-label]');
    var stickyNotify = bar.querySelector('[data-aeya-sticky-notify]');
    var sizeWrap = bar.querySelector('[data-aeya-sticky-size]');
    var sizeTrigger = bar.querySelector('[data-aeya-sticky-size-trigger]');
    var sizePop = bar.querySelector('[data-aeya-sticky-size-pop]');
    var sizeLabel = bar.querySelector('[data-aeya-sticky-size-label]');
    var sizeOpts = Array.prototype.slice.call(bar.querySelectorAll('[data-aeya-sticky-size-opt]'));
    var pos = sizeWrap ? sizeWrap.getAttribute('data-option-position') : null;
    var inPageBis = root.querySelector('[data-aeya-bis]');
    var key = bar.getAttribute('data-klaviyo-key');

    function realGroup() {
      return pos ? root.querySelector('[data-aeya-option-group][data-option-position="' + pos + '"]') : null;
    }
    function realPillFor(val) {
      var g = realGroup();
      if (!g) return null;
      var pills = g.querySelectorAll('[data-aeya-variant-option]');
      for (var i = 0; i < pills.length; i++) {
        if (pills[i].getAttribute('data-option-value') === val) return pills[i];
      }
      return null;
    }
    function selectedValue() {
      var g = realGroup();
      if (!g) return '';
      var checked = g.querySelector('[data-aeya-variant-option][aria-checked="true"]');
      return checked ? checked.getAttribute('data-option-value') : '';
    }

    function closeSizePop() {
      if (sizePop) sizePop.hidden = true;
      if (sizeTrigger) sizeTrigger.setAttribute('aria-expanded', 'false');
    }
    if (sizeTrigger && sizePop) {
      sizeTrigger.addEventListener('click', function () {
        var willOpen = sizePop.hidden;
        sizePop.hidden = !willOpen;
        sizeTrigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    }
    sizeOpts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var pill = realPillFor(opt.getAttribute('data-option-value'));
        if (pill) pill.click();
        closeSizePop();
      });
    });
    document.addEventListener('click', function (e) {
      if (!sizePop || sizePop.hidden) return;
      if (sizeWrap && !sizeWrap.contains(e.target)) closeSizePop();
    });

    var realForm = root.querySelector('.aeya-pdp-ajax') || root.querySelector('.aeya-pdp__form');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        if (realAtc.disabled || !realForm) return;
        if (realForm.requestSubmit) realForm.requestSubmit();
        else realAtc.click();
      });
    }

    var nPop = bar.querySelector('[data-aeya-sticky-notify-pop]');
    var nEmail = bar.querySelector('[data-aeya-sticky-notify-email]');
    var nSubmit = bar.querySelector('[data-aeya-sticky-notify-submit]');
    var nMsg = bar.querySelector('[data-aeya-sticky-notify-msg]');
    var nRow = bar.querySelector('[data-aeya-sticky-notify-row]');
    if (stickyNotify && nPop) {
      stickyNotify.addEventListener('click', function () {
        bar.classList.add('is-notify-open');
        nPop.hidden = false;
        if (nEmail) nEmail.focus();
      });
    }
    function nShow(ok) {
      if (!nMsg) return;
      nMsg.textContent = ok ? (nMsg.getAttribute('data-success') || '') : (nMsg.getAttribute('data-error') || '');
      nMsg.hidden = false;
      nMsg.classList.toggle('is-error', !ok);
      if (ok && nRow) nRow.hidden = true;
    }
    function nSubmitFn() {
      if (!key || !nEmail || !idField) return;
      if (!nEmail.checkValidity()) { nEmail.reportValidity(); return; }
      var addr = nEmail.value.trim();
      var variantId = idField.value;
      if (!addr || !variantId) return;
      if (nSubmit) nSubmit.disabled = true;
      postBackInStock(key, addr, variantId)
        .then(function (res) { nShow(res.ok || res.status === 202); })
        .catch(function () { nShow(false); })
        .then(function () { if (nSubmit) nSubmit.disabled = false; });
    }
    if (nSubmit) nSubmit.addEventListener('click', nSubmitFn);
    if (nEmail) {
      nEmail.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); nSubmitFn(); }
      });
    }

    function updateStickyFromDom() {
      var soldOut = !!realAtc.disabled;
      var notifyOn = inPageBis && !inPageBis.hidden;
      bar.classList.remove('is-notify-open');
      if (nPop) nPop.hidden = true;
      if (nRow) nRow.hidden = false;
      if (nMsg) nMsg.hidden = true;
      if (notifyOn && stickyNotify) {
        stickyNotify.hidden = false;
        if (stickyAtc) stickyAtc.hidden = true;
      } else {
        if (stickyNotify) stickyNotify.hidden = true;
        if (stickyAtc) {
          stickyAtc.hidden = false;
          stickyAtc.disabled = soldOut;
          if (stickyAtcLabel) {
            stickyAtcLabel.textContent = realAtcLabel ? realAtcLabel.textContent.trim() : 'ADD TO BAG';
          }
        }
      }
      var sv = selectedValue();
      if (sizeLabel && sv) sizeLabel.textContent = sv;
      sizeOpts.forEach(function (opt) {
        opt.setAttribute('aria-selected', opt.getAttribute('data-option-value') === sv ? 'true' : 'false');
      });
    }
    root._aeyaSyncSticky = updateStickyFromDom;
    updateStickyFromDom();

    var mq = window.matchMedia('(max-width: 749px)');
    var passedTop = false;
    var atcInView = false;
    var footerInView = false;

    function applyVisibility() {
      var show = mq.matches && passedTop && !atcInView && !footerInView;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (!show) closeSizePop();
    }

    if ('IntersectionObserver' in window) {
      var head = root.querySelector('.aeya-pdp__head');
      if (head) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          passedTop = !e.isIntersecting && e.boundingClientRect.top < 0;
          applyVisibility();
        }, { threshold: 0 }).observe(head);
      }
      new IntersectionObserver(function (entries) {
        atcInView = entries[0].isIntersecting;
        applyVisibility();
      }, { threshold: 0 }).observe(realAtc);

      var footer = document.querySelector('.aeya-footer') || document.querySelector('footer');
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerInView = entries[0].isIntersecting;
          applyVisibility();
        }, { threshold: 0 }).observe(footer);
      }
    }

    if (mq.addEventListener) mq.addEventListener('change', applyVisibility);
    else if (mq.addListener) mq.addListener(applyVisibility);
    window.addEventListener('resize', applyVisibility, { passive: true });
  }

  function init(root) {
    if (!root || root.dataset[INIT_FLAG] === 'true') return;
    root.dataset[INIT_FLAG] = 'true';
    initOffset(root);
    initGallery(root);
    root._aeyaUpdateLowStock = initLowStock(root);
    initVariantPicker(root);
    initQuantity(root);
    initAtc(root);
    initAccordions(root);
    initSizeGuide(root);
    initBis(root);
    initStickyBar(root);
  }

  function initAll() {
    document.querySelectorAll('.aeya-pdp[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.aeya-pdp[data-section-id]');
    if (root) init(root);
  });
})();
